module.exports = __webpack_public_path__ + "static/img/postDemandBanner.51c583e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/postDemandBanner.png
// module id = 9Lsr
// module chunks = 2